var _defs, _path, _path2, _path3;
const _excluded = ["title", "titleId"];
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
function _objectWithoutProperties(e, t) { if (null == e) return {}; var o, r, i = _objectWithoutPropertiesLoose(e, t); if (Object.getOwnPropertySymbols) { var n = Object.getOwnPropertySymbols(e); for (r = 0; r < n.length; r++) o = n[r], -1 === t.indexOf(o) && {}.propertyIsEnumerable.call(e, o) && (i[o] = e[o]); } return i; }
function _objectWithoutPropertiesLoose(r, e) { if (null == r) return {}; var t = {}; for (var n in r) if ({}.hasOwnProperty.call(r, n)) { if (-1 !== e.indexOf(n)) continue; t[n] = r[n]; } return t; }
import * as React from "react";
function SvgMenuLeftAlt(_ref, svgRef) {
  let {
      title,
      titleId
    } = _ref,
    props = _objectWithoutProperties(_ref, _excluded);
  return /*#__PURE__*/React.createElement("svg", _extends({
    xmlns: "http://www.w3.org/2000/svg",
    width: 14.661,
    height: 12.829,
    viewBox: "0 0 14.661 12.829",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _defs || (_defs = /*#__PURE__*/React.createElement("defs", null, /*#__PURE__*/React.createElement("style", null, ".a{fill:#172b4d;}"))), _path || (_path = /*#__PURE__*/React.createElement("path", {
    className: "a",
    d: "M6,8.416A.916.916,0,0,1,6.916,7.5H19.745a.916.916,0,0,1,0,1.833H6.916A.916.916,0,0,1,6,8.416Z",
    transform: "translate(-6 -7.5)"
  })), _path2 || (_path2 = /*#__PURE__*/React.createElement("path", {
    className: "a",
    d: "M6,26.416a.916.916,0,0,1,.916-.916H19.745a.916.916,0,0,1,0,1.833H6.916A.916.916,0,0,1,6,26.416Z",
    transform: "translate(-6 -14.504)"
  })), _path3 || (_path3 = /*#__PURE__*/React.createElement("path", {
    className: "a",
    d: "M6.916,16.5a.916.916,0,0,0,0,1.833h7.331a.916.916,0,0,0,0-1.833Z",
    transform: "translate(-6 -11.002)"
  })));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgMenuLeftAlt);
export default __webpack_public_path__ + "static/media/menu-left-alt.43e2862d611561ae93ce0c453a2aea9d.svg";
export { ForwardRef as ReactComponent };